// extracted by mini-css-extract-plugin
module.exports = {"content":"DeviationType_content__1fXT3","submitBtn":"DeviationType_submitBtn__3WEfq"};